'use client';

import { useGlobalClientContext } from '../common/GlobalClientContext';
import WarningOutlineIcon from '../icons/Warning.outline';
import React from 'react';

export const RequiredError = () => {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();

  return (
    <div className="text-red-500 flex flex-row gap-[6px] flex-start items-center text-xs leading-xs font-display">
      <WarningOutlineIcon />
      <span>{t('signup.error.required.field', {})}</span>
    </div>
  );
};
